import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42b8a81d"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "加密狗用户信息", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title",
  style: {
    "font-size": "22px"
  }
}, "历史记录", -1));
const _hoisted_3 = {
  style: {
    "width": "100%"
  },
  class: "descriptionsContent"
};
const _hoisted_4 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "end"
  }
};
import { findDongleUserApprovalHisPage, getDongleUser } from '@/api/dongle';
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ApplyType } from './config';
export default {
  __name: 'info',
  setup(__props) {
    const route = useRoute();
    const {
      id
    } = route.params;
    // loading效果
    const loading = ref(false);
    const dongleUserModule = ref([]);
    const dongleUser = ref({});
    const currentPage = ref(1);
    const pageSize = ref(5);
    const total = ref(0);
    const getData = async () => {
      loading.value = true;
      const dongleUserRes = await getDongleUser(id);
      dongleUser.value = dongleUserRes;
      const dongleUserModuleRes = await findDongleUserApprovalHisPage({
        userId: id,
        currentPage: currentPage.value,
        pageSize: pageSize.value
      });
      dongleUserModule.value = dongleUserModuleRes.records;
      total.value = dongleUserModuleRes.total;
      loading.value = false;
    };
    const handleCurrentChange = e => {
      currentPage.value = e;
      getData();
    };
    const handleChangeSize = e => {
      pageSize.value = e;
      getData();
    };
    const router = useRouter();
    const handleApproval = row => {
      router.push(`/application/approval/${row.id}`);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
        shadow: "never",
        class: "container"
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_descriptions, {
          border: "",
          class: "descriptionsContent"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "加密狗编号"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dongleUser.value.name), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "安全手机"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dongleUser.value.mobile), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 1,
            label: "联系人姓名"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dongleUser.value.contactName || '暂未填写'), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "租户"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dongleUser.value.tenantName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "诊所"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dongleUser.value.clinicName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 3,
            label: "备注信息"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dongleUser.value.remark), 1)]),
            _: 1
          })]),
          _: 1
        }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_table, {
          data: dongleUserModule.value,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "moduleConfigName",
            label: "加密狗版本名",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            prop: "beginTime",
            label: "开始日期"
          }), _createVNode(_component_el_table_column, {
            prop: "endTime",
            label: "结束日期"
          }), _createVNode(_component_el_table_column, {
            prop: "lastPayTime",
            label: "最后续费时间"
          }), _createVNode(_component_el_table_column, {
            prop: "lastPayTime",
            label: "操作说明"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(_unref(ApplyType)[row === null || row === void 0 ? void 0 : row.applyApprovalType]), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "lastPayTime",
            label: "应用状态"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(row.applyStatus === 1 ? '使用中' : '停用'), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "lastPayTime",
            label: "审核状态"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(row.approvalStatus === 1 ? '进行中' : row.approvalStatus === 2 ? '审批完成' : '拒绝'), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => handleApproval(row)
            }, {
              default: _withCtx(() => [_createTextVNode("审批")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [5, 10, 15],
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total, sizes, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])])]),
        _: 1
      })), [[_directive_loading, loading.value]]);
    };
  }
};